/* eslint-disable quotes */
/* eslint-disable max-len */
import React, { Component } from 'react';
import Modal from '../common/Modal';
import warningIcon from '../images/warning-icon.png'

export class AgentInfoVerificationConfirmationModal extends Component {
  state = {
    isModalOpen: true,
    fadeModalOut: false,
  }

  // used for Agent Info Verification
  toggleModal = () => {
    if (this.state.isModalOpen) {
      this.props.agentInfoVerificationSubmitted(false)
      // sets fadeModalOut flag to true. Common Modal will detect prevProp change and will fade out modal
      // when modal fades out, isModalOpen is set to false and modal is destroyed
      this.setState({ fadeModalOut: true }, () => {
        setTimeout(() => {
          this.setState({ isModalOpen: false })
        }, 1000)
      })
    } else {
      this.setState({ fadeModalOut: false, isModalOpen: true })
    }
  }

  render() {
    const { fadeModalOut, isModalOpen } = this.state;
    
    return (
      <div className="AIV__confirmation">
        { isModalOpen &&
          <Modal
              domQuery="body"
              toggleModal={this.toggleModal}
              fadeModalOut={fadeModalOut}
          >
            <div className="AgentInfoVerificationModal">
              <div className="AgentInfoVerificationModal__title">
                Almost done...
              </div>
              <div className="AgentInfoVerificationModal__subtitle">
                {/* <img src={warningIcon} alt="warning-icon"/> */}
                Your form has been submitted.
              </div>
              <div className="AgentInfoVerificationModal__body-text">
                <img src={warningIcon} alt="warning-icon"/>
                <span>  
                  Updates to your personal information requires additional verification steps.
                  <br></br>
                  <br></br>
                  To confirm the changes, please check your email that was provided in the previous form and click on the verification link.
                </span>
              </div>
              <button className="AgentInfoVerificationModal__close" onClick={ this.toggleModal }>
                  OK
              </button>
            </div>
          </Modal>
        }
      </div>
    );
  }
}

export default AgentInfoVerificationConfirmationModal;


// WEBPACK FOOTER //
// ./src/features/agent-info-verification/components/AgentInfoVerificationConfirmationModal.js